import DOMPurify from 'dompurify';

// Configure DOMPurify for safe HTML sanitization
const createDOMPurify = () => {
  if (typeof window !== 'undefined') {
    return DOMPurify;
  }
  // For server-side rendering, return a no-op sanitizer
  return {
    sanitize: (dirty: string, config?: any): string => dirty
  };
};

const purify = createDOMPurify();

export const sanitizeHtml = (dirty: string): string => {
  return purify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true
  }) as string;
};

export const sanitizeText = (input: string): string => {
  if (!input || typeof input !== 'string') return '';
  
  // Remove any HTML tags and decode HTML entities
  return input
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#x27;/g, "'")
    .trim();
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone: string): boolean => {
  const phoneRegex = /^\+?[0-9\s\-\(\)]{10,20}$/;
  return phoneRegex.test(phone);
};

export const sanitizeNumericInput = (input: string): number | null => {
  const num = parseFloat(input.replace(/[^0-9.-]/g, ''));
  return isNaN(num) ? null : num;
};

export const sanitizeSearchQuery = (query: string): string => {
  if (!query || typeof query !== 'string') return '';
  
  // Allow only alphanumeric characters, spaces, and basic punctuation
  return query
    .replace(/[^a-zA-Z0-9\s\u0600-\u06FF\u0750-\u077F\-_.]/g, '')
    .trim()
    .substring(0, 100); // Limit length
};
